import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import About from "@/views/About";
import News from "@/views/News";
import PublicPrivateBodies from "@/views/PublicPrivateBodies";
import WhereWeWork from "@/views/WhereWeWork";
import Contact from "@/views/Contact";
import PublicBodies from "@/views/PublicBodies";
import PrivateBodies from "@/views/PrivateBodies";

Vue.use(Router);

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/news/:slug?',
      name: 'news',
      component: News
    },
    {
      path: '/bodies',
      name: 'bodies',
      component: PublicPrivateBodies
    },
    {
      path: '/public-bodies',
      name: 'public-bodies',
      component: PublicBodies
    },
    {
      path: '/private-bodies',
      name: 'private-bodies',
      component: PrivateBodies
    },
    {
      path: '/where-we-work/:slug?',
      name: 'www',
      component: WhereWeWork
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact
    }
  ]
})
